import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

import * as Sentry from "@sentry/angular";

if (environment.production) {
  enableProdMode();

  // Disable console.log in production
  // window.console.log = () => {};
  // window.console.warn = () => {};
  // window.console.info = () => {};
  // window.console.debug = () => {};
}

Sentry.init({
  dsn: "https://9c89b4689f7f3ad15e857ae548c9daa4@o4507259142275072.ingest.us.sentry.io/4507259146534912",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["https://merchant.smartie.com"], // Just production merchant
  // Session Replay
  replaysSessionSampleRate: 1.0, // This sets the sample rate at 100% (previous was 10%). You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// enableProdMode();
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
